import { Controller, useFormContext } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';
import { Flex, Text } from '@theme-ui/components';
import { css } from '@emotion/react';
import styled from '@emotion/styled';

import Card from '@app/components/Card';
import { rem } from '@app/styles/theme/layout';

import { AddressFormFields } from '../Address.constants';
import messages from '../Address.messages';
import { FormVisibilityState } from '../Address.types';

const AddAddressButton = () => {
  const { setValue, clearErrors } = useFormContext();

  return (
    <Controller
      name={AddressFormFields.FormVisibility}
      defaultValue="hidden"
      render={({ field: { onChange, value } }) => (
        <Card
          data-testid="add-address-button"
          as="button"
          css={css`
            cursor: pointer;
            width: 100%;
            height: 100%;
            padding-top: ${rem(10)};
            padding-bottom: ${rem(10)};
          `}
          onClick={() => {
            onChange(
              value === FormVisibilityState.SHOWN
                ? FormVisibilityState.HIDDEN
                : FormVisibilityState.SHOWN,
            );
            setValue(AddressFormFields.Selected, null);
            clearErrors();
          }}
        >
          <Flex sx={{ alignItems: 'center', justifyContent: 'center' }}>
            <ExpandSign isExpanded={value === FormVisibilityState.SHOWN} />

            <Text
              sx={{
                fontWeight: 500,
                fontSize: rem(20),
                display: 'inline-block',
                margin: `0 0 0 ${rem(10)}`,
              }}
            >
              <FormattedMessage {...messages.addAddressButtonLabel} />
            </Text>
          </Flex>
        </Card>
      )}
    />
  );
};

export default AddAddressButton;

const ExpandSign = styled.span<{ isExpanded: boolean }>`
  &::before {
    content: ${(props) => (props.isExpanded ? '"-"' : '"+"')};
    display: block;
    width: 2rem;
    height: 2rem;
    border: 2px solid #000;
    border-radius: 50%;
    font-size: 1.25rem;
    font-weight: 500;
  }
`;
